import { useQuery } from "@apollo/client"
import { TOURNAMENT_TYPES_LIST, TOURNAMENT_TYPES_LIST_PLAIN } from "../queries/tournamentTypesList"

export interface TournamentType {
  id: number
  name: string
  private?: boolean
  status?: number
  storeTournaments?: number
  multiplier?: number
  canBeDouble?: number
}

export interface TournamentTypesInput {
  storeId: number
}

export const useTournamentTypesList = (input: TournamentTypesInput) => {
  const { data, loading, error, refetch } = useQuery<{
    TournamentTypesList: {
      status: {
        name: string
        success: boolean
        detail: string
      }
      TournamentTypes: TournamentType[]
    }
  }>(TOURNAMENT_TYPES_LIST, {
    variables: { TournamentTypesInput: input },
    errorPolicy: "all",
    skip: !input.storeId,
  })

  return {
    tournamentTypes: data?.TournamentTypesList?.TournamentTypes || [],
    status: data?.TournamentTypesList?.status,
    loading,
    error,
    refetch,
  }
}

export const useTournamentTypesListPlain = () => {
  const { data, loading, error, refetch } = useQuery<{
    allTournamentTypes: TournamentType[]
  }>(TOURNAMENT_TYPES_LIST_PLAIN, {
    errorPolicy: "all",
  })

  return {
    types: data?.allTournamentTypes ?? [],
    loading,
    error,
    refetch,
  }
}
